<template>
    <v-container class="fill-height" fluid color="blue">
        <v-card class="mx-auto">
            <v-card-title>Error 404</v-card-title>
            <v-card-text>
                Page not found.
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>
